<template>
  <div>
    <Header/>
    <div id="login-screen">
      <div class="d-block carlogin-container">
        <div class="d-flex align-items-center justify-content-center ">
          <cardlogin :cardStyle="'bg-white border-blue'" :cadastro="true" />
        </div>
      </div>
      <footersite class="d-none d-xl-block" />
      <footersitemobile class="d-block d-xl-none"/>
    </div>
  </div>
</template>
<script>
  import LeftPanel from "../views/Login/LeftPanel.vue";
  import Serv from "../services";
  import APIConsulta from "../services/api_consulta";
  import API from "../services/api";
  import { setTimeout } from "timers";
  import cardlogin from '../components/login/card_login';
  import Header from '../components/Header';
  import footersite from "../components/footersite";
  import footersitemobile from "../components/footersite/index_mobile";

  export default {
    props: ["tipo_login"],
    components: {
      LeftPanel,
      cardlogin,
      Header,
      footersite,
      footersitemobile
    },
    data() {
      return {
        sitekey: process.env.VUE_APP_sitekeyRecaptchaInvisivel,
        erroCert: "",
        loading: false,
        cpf_state: null,
        cpf: "",
        tok: "",
        senha_state: null,
        senha: "",
        falha_login: false,
        falha_login_msg: '',
        okclicked: false,
        loginComCertificado: false,
      };
    },
    methods: {
      onVerify: function (response) {
        this.tok = response
      },
      onExpired: function () {
        this.$refs.invisibleRecaptcha.reset()
      },
      resetRecaptcha() {
        this.$refs.invisibleRecaptcha.reset() // Direct call reset method
      },
      validarLogin() {
        if (this.cpf.length > 0 && this.senha.length > 0 && this.tok) {
          this.$root.clearLocalStorage();
          if (!this.okclicked) {
            this.erroCert = 'Para realizar envio de títulos a protesto ou emitir carta de anuência eletrônica, é necessário realizar o login por meio de Certificado Digital ICP-Brasil'
            this.$refs['modalErroCert'].show();
          }
          if (this.okclicked) {
            localStorage.setItem("libProcuracao", 'false');
            localStorage.setItem("libAnuencia", 'false');
            this.loading = true
            this.falha_login = false
            let cpf = this.validar()
            let senha = this.senha
            if (cpf) {
              if (senha != '') {
                this.cpf = cpf
                this.$root.login(this.cpf, this.senha, this.tok).then((res) => {
                  localStorage.setItem("jwtToken", res.token)
                  sessionStorage.setItem("jwtToken", res.token)
                  localStorage.setItem("usrName", res.name)
                  localStorage.setItem("usrEmail", res.email)
                  localStorage.setItem("usrCpf", res.cpf)

                  if (this.tipo_login === "solicitarCertidao") {
                    this.$router.push({ name: "emolumentos" })
                  } else {
                    this.$router.push({ name: "painel" })
                  }
                  this.loading = false

                }).catch((res) => {
                  this.resetRecaptcha()
                  if (res.error === 1)
                    this.falha_login_msg = 'CPF não encontrado.'
                  else
                    this.falha_login_msg = 'Senha inválida.'
                  this.falha_login = true
                  this.loading = false
                })
              }
            } else {
              alert('Usuário ou senha inválido')
              this.loading = false
            }
          }
        } else {
          this.$refs['modalErroCert'].hide();
        }
      },
      validar() {
        //console.log(this.cpf.length)
        let cpf = this.cpf.replace(/\./g, "").replace("-", "");
        let cpf_valido = null;

        if (this.cpf.length === 14) 
          cpf_valido = Serv.validarCNPJ(cpf) ? null : false;
        else 
          cpf_valido = Serv.validarCPF(cpf) ? null : false;

        this.cpf_state = !this.cpf ? false : cpf_valido !== false ? null : false;
        this.senha_state = !this.senha ? false : null;
        if (this.cpf && this.senha && cpf_valido === null) 
          return cpf;
      },
      mascaraCPF(event) {
        var ao_cpf = event.target.value;
        var cpfValido = /^(([0-9]{3}.[0-9]{3}.[0-9]{3}-[0-9]{2}))$/;
        if (cpfValido.test(ao_cpf) == false) {
          ao_cpf = ao_cpf.replace(/\D/g, ""); //Remove tudo o que não é dígito
          if (ao_cpf.length == 11) {
            ao_cpf = ao_cpf.replace(/(\d{3})(\d)/, "$1.$2"); //Coloca um ponto entre o terceiro e o quarto dígitos
            ao_cpf = ao_cpf.replace(/(\d{3})(\d)/, "$1.$2"); //Coloca um ponto entre o terceiro e o quarto dígitos
            //de novo (para o segundo bloco de números)
            ao_cpf = ao_cpf.replace(/(\d{3})(\d{1,2})$/, "$1-$2"); //Coloca um hífen entre o terceiro e o quarto dígitos
            event.target.value = ao_cpf;
            document.getElementById("senha").focus();
          }
        }
      },
      CPF_Monitor(event) {
        if (
          (event.which >= 48 && event.which <= 57) ||
          (event.which >= 96 && event.which <= 105) ||
          (event.which == 8 ||
            event.which == 46 ||
            event.which == 37 ||
            event.which == 39)
        )
          setTimeout(() => {
            this.mascaraCPF(event);
          }, 10);
        else {
          event.preventDefault();
        }
      },
      goHome() {
        this.$router.push({ name: "home" });
      },
      async certLogin() {
        this.loginComCertificado = true
        this.cpf = null
        this.senha = null
        // if (this.cpf.length == 0 && this.senha.length == 0) {
          this.$refs['modalLoading'].show();
          const res = await APIConsulta.get(`pki/login/cenprotPublico`).catch(() => {
            this.erroCert = "<h5><b><font color='red'>Antes de realizar o login no site. <a href='cadastro'>Clique aqui e faça seu cadastro</a></font></b></h5>"
            this.erroCert += "<hr><b>Erro ao acessar com o Certificado Digital</b>"
            this.erroCert += "<br>Siga os passos para a correção: <br>"
            this.erroCert += "<b class='ml-3'>•	Limpeza de cache do navegador</b>:"
            this.erroCert += "<p class='ml-4'> Após esse procedimento, deve-se fechar <font color='red'>todas</font> as abas do navegador e acessar o site novamente.</p>"
            this.erroCert += "<p class='ml-4'>Para limpeza total do cache, deve-se utilizar o comando <b>CTRL + SHIFT + DEL</b>, após isso deve se selecionar em <b>“Período” - > Todo período</b> e marcar <b>TODOS</b> os quadrados, depois clicar no botão “limpar dados”, e deve-se aguardar o que a janela se feche e depois abrir o navegador de novo.</p>"
            this.erroCert += " <b class='ml-3'>•	Remover certificado(s) vencido(s):</b> <p class='ml-4'> Para isso, acesse o Painel de Controle -> Rede e Internet -> Opções da Internet,com isso será aberta uma nova janela, selecione a aba <b>Conteúdo</b> e depois <b>Certificados.</b> <br>Será possível ver se o seu certificado está vencido ou não.<br>Caso tenha algum certificado vencido, o mesmo deve ser removido.</p>"
            this.erroCert += "<b class='ml-3'>•	Antivírus:</b><p class='ml-4'>Alguns antivírus negam o acesso á sites com a utilização do certificado digital, e toda a cadeia de certificação. Neste caso, é necessário inativá-lo para que possa acessar o site com seu certificado digital.</p><p class='ml-4'>Antivírus como o <b>Kaspersky, FortClient</b> e <b>Avast</b>, podem bloquear o acesso ao site, por não estarem configurados para isso, pedimos que inativem o mesmo para acesso ao site.</p>"
            this.erroCert += "<b class='ml-3'>•	Bloqueio de IP ou Proxy:</b><p class='ml-4'>Algumas redes de internet empresárias possuem bloqueio de IP para acesso á alguns sites, por isso deve consultar o <b>TI</b> da sua empresa para que faça, <b>se tiver</b>, o desbloqueio do site através do IP do site da Cenprot.</p>"
            this.erroCert += " <b class='ml-3'>•	Verificação da Cadeia de Certificação ICP-Brasil:</b> <br> <p class='ml-4'>É de extrema importância que seja feito essa verificação, devido ao fato de que o Site da Cenprot utiliza dessa cadeia de certificação para acesso ao site.</p><br>"
            this.erroCert += " <p class='ml-4'>Como fazer essa verificação: <br> Acesse o Painel de Controle -> Rede e Internet -> Opções da Internet, com isso será aberta uma nova janela, selecione a aba <b>Conteúdo</b> e depois <b>Certificados</b>, com isso será listado o(s) certificado(s) presentes na sua maquina, com isso localize aquele que irá acessar o Site da Cenprot, de dois cliques com o botão esquerdo, ele irá abrir uma tela com os dados do certificado, com isso vá em <b>“Caminho de Certificação”</b>, e <font color='red'>DEVE</font> conter toda a cadeia de certificação, desde a ICP-Brasil até o seu. Feito isso, é só fechar tudo e acessar o site.</p>"
            this.erroCert += " <b class='ml-3'>•	Atenção:</b> <br> <p class='ml-4'>Qualquer mensagem que apresente em <b>“Caminho de Certificação”</b>, em toda a cadeia, que seja <b><font color='red'>DIFERENTE</font></b> de “ESSE CERTIFICADO É VÁLIDO”, você deve entrar em contato com o responsável sobre isso da sua empresa ou a empresa certificadora do <font color='red'>SEU</font> certificado.</p><br>"
            this.erroCert += " <p class='ml-4'> Recomendamos também a utilização somente do navegador Google Chrome, devido a sua facilidade em questão do certificado digital. Caso você tenha seguido os passos e mesmo assim ainda não conseguiu acessar, entrar em contato através do (11) 3112-0698.</p>";

            this.$refs['modalErroCert'].show();
            this.$refs['modalLoading'].hide();
          })
          //console.log(res.data.nm_nr_documento);
          if (res != null )
          {
            if(res.data.ic_autenticado > 0) {
              if (res.data.sg_tipo_documento == "CNPJ") {
                localStorage.setItem("libProcuracao", 'true');
              }
              else {
                localStorage.setItem("libProcuracao", 'false');
              }
              localStorage.setItem("libAnuencia", 'true');
  
              localStorage.setItem("nm_thumbprint", res.data.nm_thumbprint)
              localStorage.setItem("nm_thumbprint_sha256", res.data.nm_thumbprint_sha256)
              localStorage.setItem("sg_tipo_documento", res.data.sg_tipo_documento)
              localStorage.setItem("nm_nr_documento_cert", res.data.nm_nr_documento)
              localStorage.setItem("SSL_CLIENT_S_DN_CN", res.data.SSL_CLIENT_S_DN_CN)
              localStorage.setItem("nm_tipo_certificado", res.data.nm_tipo_certificado)
              localStorage.setItem("SSL_CLIENT_S_DN", res.data.SSL_CLIENT_S_DN)
              localStorage.setItem("SSL_CLIENT_V_START", res.data.SSL_CLIENT_V_START)
              localStorage.setItem("SSL_CLIENT_V_END", res.data.SSL_CLIENT_V_END)
  
              const resLogin = await API.post(`auth/login/cert`, { cpf: res.data.nm_nr_documento })
              localStorage.setItem("jwtToken", resLogin.data.token)
              sessionStorage.setItem("jwtToken", resLogin.data.token)
              localStorage.setItem("usrName", resLogin.data.name)
              localStorage.setItem("usrEmail", resLogin.data.email)
              localStorage.setItem("usrCpf", resLogin.data.cpf)
              //console.log(resLogin.data.token);
              this.$refs['modalLoading'].hide();
              if (this.tipo_login === "solicitarCertidao") {
                this.$router.push({ name: "emolumentos" })
              } else {
                this.$router.push({ name: "painel" })
              }
            }
            else {
              //this.$router.push({ name: "painel" })
              this.$refs['modalLoading'].hide();
              this.erroCert = "Usuário do certificado não cadastrado"
              this.$refs['modalErroCert'].show();
            }
         }
      },
      confirmaleitura(confirma) {
        if (this.loginComCertificado) {
          this.cpf = ''
          this.senha = ''
        }
        if (confirma == 's') {
          this.okclicked = true;
          this.validarLogin();
        }
        else this.$refs['modalErroCert'].hide();
      }
    },
    created: function () {
      this.$root.isLogged();
      let token = sessionStorage.getItem('jwtToken');
      if (token && token !== undefined) this.$router.push({ name: "painel" });
      if(this.$route.query.code) this.$root.loginGov(this.$route.query.code);
      //console.log(process.env.VUE_APP_sitekeyRecaptcha);
    },
  };
</script>

<style scoped>

  #login-screen .carlogin-container{margin-bottom: 96px !important;}
  @media(min-width: 300px) AND (max-width: 700px) {
    .cancelar {
      margin-right: 27%;
    }
  }

  @media(min-width: 701px) AND (max-width: 3000px) {
    .cancelar {
      margin-right: 70%;
    }
  }

  .cancelar {
    margin-left: -20%;
  }

  ::placeholder {
    color: #bbb;
  }

  .logo {
    cursor: pointer;
    margin-bottom: 30px;
    height: 70px;
  }

  #login-screen {
    position: absolute;
    height: auto;
    width: 100%;
    padding-top: 55px;
    /* margin-top: 120px; */
    /* background-color: var(--main-bg-cinza); */
  }
  #login-screen .d-block {
    margin: 0 auto;
  }

  #login-screen .right-panel {
    position: absolute;
    right: 0%;
    width: 57%;
    height: 100%;
  }

  .ou {
    font-size: 20px;
    color: #004E86;
  }

  .textBlue {
    color: #004E86 !important;
  }

  .blueE {
    color: #004E86;
    font-size: 30px;
  }


  /* OCULTO POR ENQUANTO */
  .card-header {
    display: none;
    cursor: pointer;
    background-color: #294;
    color: #fff;
  }

  .card-header span {
    font-size: 1.15rem;
    margin-right: 10px;
  }

  .crie-cadastro {
    cursor: pointer;
    font-family: "Kanit", sans-serif !important;
    color: #004E86 !important;
  }

  #loading-entrar {
    vertical-align: 0;
    margin-left: -21px;
  }

  @media (min-width: 360px) and (max-width:800px) {
    img {
      max-width: 180px !important;
    }

    .card-title {
      font-size: 24px !important;
    }
  }
  @media (max-width: 1199px) {
    #login-screen{padding-top: 41px;padding-bottom:0px;}
    
    #login-screen .carlogin-container{margin-bottom: 43px !important;}
  }
</style>